<script lang="ts">
	import captureClick from '$lib/actions/captureClick';

	interface Props {
		open: boolean;
		color: 'white' | 'brown';
		onclick?: () => void;
	}

	let { open, color, onclick }: Props = $props();
</script>

<button
	aria-label="Close"
	use:captureClick
	title="Burger menu"
	class={[
		'flex h-10 w-10 flex-col items-center justify-center gap-y-2 rounded-full p-3 transition-colors duration-300',
		open && 'bg-brown-1'
	]}
	{onclick}
>
	<class
		class={[
			'h-[2px] w-[17px] rounded-lg transition-all duration-400',
			open && 'translate-y-[5px] rotate-45 bg-white',
			color === 'white' ? 'bg-white  lg:group-hover:bg-brown-1' : 'bg-brown-1'
		]}
	></class>
	<class
		class={[
			'h-[2px] w-[17px] rounded-lg  transition-all duration-400',
			open && '-translate-y-[5px] -rotate-45 bg-white',
			color === 'white' ? 'bg-white  lg:group-hover:bg-brown-1' : 'bg-brown-1'
		]}
	></class>
</button>
